/**
 * Tipos de interactiones para Ws de Interaction
 */
export enum TypeInteraction {
    ASSIGNMENT = 'Asignación cita',
    ATTENTION = 'Atención cita',
    PREPARATION = 'Preparación cita',
    MODIFICATION = 'Modificación cita',
    CANCELLATION = 'Cancelación cita'
}